import { useState, useEffect, useRef } from 'react';
import { dmsApi } from '../services/dmsApi';

export function useAgentSuggestions({ mode, content, selection, documentId, chapterId, enabled = true, debounceMs = 2500 }) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);
  const hashRef = useRef('');

  useEffect(() => {
    if (!enabled || !content) return;

    const payload = JSON.stringify({ mode, content, selection, chapterId });
    if (payload === hashRef.current) return;

    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      hashRef.current = payload;
      setLoading(true);
      try {
        const res = await dmsApi.agentSuggestions({
          mode,
          content,
          selection,
          documentId,
          chapterId,
        });
        setSuggestions(res.suggestions || []);
      } catch {
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, debounceMs);

    return () => clearTimeout(timerRef.current);
  }, [mode, content, selection, documentId, chapterId, enabled, debounceMs]);

  return { suggestions, loading, clearSuggestions: () => setSuggestions([]) };
}